<template>
  <el-card class="box-card">
    <template #header>
      <div class="card-header">
        <el-page-header content="修改" @back="$router.back()" />
      </div>
    </template>
    <el-form label-width="120px" label-position="top">
      <el-form-item label="公司名称">
        <el-input v-model="keyword" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="clearData">清除</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="公司名称">
      </el-table-column>
      <el-table-column
        prop="xydm"
        label="信用代码">
      </el-table-column>
      <el-table-column
        prop="clrq"
        label="成立日期"
        :formatter="formatter">
      </el-table-column>
      <el-table-column
        prop="jzrq"
        label="进驻日期"
        :formatter="formatter">
      </el-table-column>
      <el-table-column
        prop="zczb"
        label="注册资本">
      </el-table-column>
      <el-table-column
        prop="yyqx"
        label="营业期限">
      </el-table-column>
      <el-table-column
        prop="cType"
        label="类型">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.close&&(scope.row.close===1||scope.row.close.data[0]===1) ? 'info' : 'success'"
            disable-transitions>{{scope.row.close&&(scope.row.close===1||scope.row.close.data[0]===1)?'封存':'正常'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row, 1)">编辑信息</el-button>
          <el-button
            size="mini"
            @click="handleEdit(scope.row, 2)">知识产权</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="pageSize"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :hide-on-single-page="true"
      @current-change="handleCurrentChange">
    </el-pagination>

    <el-dialog
      title="公司信息"
      :visible.sync="dialogInfoVisible"
      :destroy-on-close="true">
      <Company :company="currentData" :isNew="false" @saveSuccess="dialogInfoVisible=false"/>
    </el-dialog>

    <el-dialog
      title="知识产权"
      :visible.sync="dialogPropVisible"
      :destroy-on-close="true">
      <Property :companyId="currentData.cId" :isNew="false" :propList="currentListData" v-if="currentData&&currentData.cId>0"/>
    </el-dialog>
  </el-card>
</template>

<script>
import util from '../plugins/util'
import Company from '../components/company.vue'
import Property from '../components/property.vue'
export default {
  components: {
    Company,
    Property
  },
  data () {
    return {
      keyword: '',
      pageIndex: 1,
      pageSize: 5,
      tableData: [],
      total: 0,
      dialogInfoVisible: false,
      dialogPropVisible: false,
      currentData: {},
      currentListData: []
    }
  },
  created () {
    if (!sessionStorage.getItem('jId')) {
      this.$router.push('/login').then()
    }
  },
  methods: {
    onSubmit () {
      const params = {
        keyword: this.keyword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      // console.log(params)
      this.$http.get(this.apiUrl + '/sys/getlist', { params: params })
        .then(response => {
          // console.log(response)
          if (response.status === 200) {
            let datas = response.data
            this.tableData = datas.data
            this.total = datas.total
          } else {
            this.$message.error('查询失败，请检查数据库连接')
          }
        })
    },
    handleCurrentChange (val) {
      this.pageIndex = val
      this.onSubmit()
    },
    handleEdit (row, active) {
      // console.log(row)
      if (active === 1) {
        this.currentData = row
        this.dialogInfoVisible = true
      } else if (active === 2) {
        this.getPropList(row)
      }
    },
    getPropList (row) {
      this.currentData = {}
      this.currentListData = []
      this.$http.get(this.apiUrl + '/sys/getPropertiesByCom', { params: {cId: row.cId} })
        .then(response => {
          // console.log(response)
          if (response.status === 200) {
            let datas = response.data
            this.currentData = row
            this.currentListData = datas.data
            this.dialogPropVisible = true
          } else {
            this.$message.error('查询失败，请检查数据库连接')
          }
        })
    },
    formatter (row, column) {
      // console.log(row, column)
      const date = row[column.property]
      return date && !(date.indexOf('0000') > -1) ? util.formatDate.format(new Date(date), 'yyyy-MM-dd') : '-'
    },
    clearData () {
      this.keyword = ''
      this.pageIndex = 1
      this.tableData = []
      this.total = 0
    }
  }
}
</script>

<style scoped>
.box-card {
  width: calc(100% - 4rem - 2px);
  min-height: calc(100% - 4rem - 2px);
  margin: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/edit.vue